import React, { useContext, useState } from "react";
import Aside from "./layout/Aside";
import Content from "./Content";
import ProgressBar from "@ramonak/react-progress-bar";
import { CourseContext } from "./CourseContext";

const Dashboard = () => {
  const {
    progress,
    topicstatus,
    sections,
    setPages,
    pages,
    topic,
    setTopic,
    refreshSections,
    currentSection,
    setCurrentSection,
    courseStatus,
    startcourse,
    setStartCourse,
    // ui state
    showSuccess,
    setShowSuccess,
    quizalert,
    setQuizalert,
    sidebarlock,
    setSidebarlock,
    // Security Challenge state for QA testing
    totalTimeElapsed,
    breakpoint1,
    breakpoint2,
  } = useContext(CourseContext);

  // Format seconds to HH:MM:SS
  const formatTime = (seconds) => {
    if (seconds === null || seconds === undefined) return 'N/A';
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  // Format seconds to readable format with label
  const formatTimeWithLabel = (seconds) => {
    if (seconds === null || seconds === undefined) return 'Not Set';
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    if (hrs > 0) {
      return `${hrs}h ${mins}m ${secs}s (${seconds}s)`;
    } else if (mins > 0) {
      return `${mins}m ${secs}s (${seconds}s)`;
    } else {
      return `${secs}s (${seconds}s)`;
    }
  };

  const [showMobileToc, setShowMobileToc] = useState(false);
  const clampedProgress = Math.min(100, Number(progress) || 0);

  return (
    <>
      {/* Mobile-only progress bar directly under header, above content */}
      <div className="row d-md-none mb-2">
        <div className="col-12">
          <div className="progressbarcard " style={{ fontSize: "1rem" }}>
            <h3 className="fs-6 mb-1">Overall Progress</h3>
            {console.log("progress",progress)}
            <ProgressBar
              completed={clampedProgress}
              borderRadius="50px"
              bgColor="#00AAAA"
              labelSize="12px"
              labelAlignment="outside"
              isLabelVisible="true"
              animateOnRender="true"
            ></ProgressBar>
            <small>
              {clampedProgress}% Completed
            </small>
          </div>
        </div>
      </div>

      {/* Mobile: content / TOC controls just under progress bar */}
      <div className="row d-md-none align-items-center mb-2" style={{ fontSize: "1rem" }}>
        <div className="col-6">
          <h5 className="mb-0 fs-6">Course Content</h5>
        </div>
        <div className="col-6 text-end">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => setShowMobileToc((prev) => !prev)}
          >
            {showMobileToc ? "Hide Chapters" : "Show Chapters"}
          </button>
        </div>
      </div>

      <div className="row align-items-stretch">
        {/* Sidebar: visible on tablet / desktop, toggleable on mobile */}
        <div className={`col-12 col-md-5 col-lg-4 ${showMobileToc ? 'd-block' : 'd-none'} d-md-block order-md-1 mb-md-0 mb-3`}>
          {/* Desktop / tablet progress bar in sidebar */}
          <div className="progressbarcard p-3 d-none d-md-block">
            <h3>Overall Progress</h3>
            <ProgressBar 
              completed={clampedProgress} 
              borderRadius = "50px"
              bgColor="#00AAAA"
              labelSize="12px"
              labelAlignment="outside"
              isLabelVisible="true"
              animateOnRender="true"
            ></ProgressBar>
            <span>{clampedProgress}% Completed</span>
          </div>

          <Aside
            topicstatus={topicstatus}
            setQuizalert={setQuizalert}
            sections={sections}
            setPages={setPages}
            setTopic={setTopic}
            setShowSuccess={setShowSuccess}
            showSuccess={showSuccess}
            sidebarlock={sidebarlock}
            setCurrentSection={setCurrentSection}
            disableSticky={true}
            compact={true}
            onTopicSelect={() => setShowMobileToc(false)}
          />
        </div>
        <div className="col-12 col-md-7 col-lg-8 order-1 order-md-2 pt-1 pt-md-0">
          <Content
            pages={pages}
            quizalert = {quizalert}
            setQuizalert = {setQuizalert}
            setSidebarlock = {setSidebarlock}
            sections={sections}
            topicstatus={topicstatus}
            setPages={setPages}
            setCurrentSection = {setCurrentSection}
            topic={topic}
            setReload={()=>{}}
            reload={false}
            setTopic={setTopic}
            showSuccess = {showSuccess}
            setShowSuccess={setShowSuccess}
            refreshSections={refreshSections} 
            currentSection = {currentSection}
            courseStatus = {courseStatus}
            startcourse = {startcourse}
            setStartCourse = {setStartCourse}
          />
        </div>
      </div>

      {/* QA Testing Panel - Row at the end */}
      <div className="row mt-3">
        <div className="col-12">
          <div 
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #00AAAA',
              borderRadius: '6px',
              padding: '10px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              fontFamily: 'monospace',
              fontSize: '11px',
            }}
          >
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '8px',
              paddingBottom: '6px',
              borderBottom: '1px solid #00AAAA'
            }}>
              <h6 style={{ 
                margin: 0, 
                color: '#00AAAA', 
                fontWeight: 'bold',
                fontSize: '12px'
              }}>
                🧪 QA Testing Panel
              </h6>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', flexWrap: 'wrap' }}>
              {/* Time Elapsed */}
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '8px 12px',
                borderRadius: '4px',
                border: '1px solid #dee2e6',
                flex: '1',
                minWidth: '150px'
              }}>
                <div style={{ 
                  fontWeight: 'bold', 
                  color: '#495057',
                  marginBottom: '4px',
                  fontSize: '10px',
                  textTransform: 'uppercase'
                }}>
                  ⏱️ Time Elapsed
                </div>
                <div style={{ 
                  color: '#00AAAA', 
                  fontWeight: 'bold',
                  fontSize: '14px',
                  fontFamily: 'monospace',
                  lineHeight: '1.3'
                }}>
                  {formatTime(totalTimeElapsed)}
                </div>
                <div style={{ 
                  color: '#6c757d', 
                  fontSize: '10px',
                  marginTop: '2px'
                }}>
                  ({totalTimeElapsed !== null ? `${totalTimeElapsed}s` : 'N/A'})
                </div>
              </div>

              {/* Breakpoint 1 */}
              <div style={{
                backgroundColor: '#fff3cd',
                padding: '8px 12px',
                borderRadius: '4px',
                border: '1px solid #ffc107',
                flex: '1',
                minWidth: '150px'
              }}>
                <div style={{ 
                  fontWeight: 'bold', 
                  color: '#856404',
                  marginBottom: '4px',
                  fontSize: '10px',
                  textTransform: 'uppercase'
                }}>
                  🎯 Breakpoint 1
                </div>
                <div style={{ 
                  color: '#856404', 
                  fontWeight: 'bold',
                  fontSize: '13px',
                  fontFamily: 'monospace',
                  lineHeight: '1.3'
                }}>
                  {breakpoint1 !== null ? `${breakpoint1}s` : 'Not Set'}
                </div>
                {breakpoint1 !== null && totalTimeElapsed !== null && (
                  <div style={{ 
                    color: totalTimeElapsed >= breakpoint1 ? '#dc3545' : '#28a745',
                    fontSize: '10px',
                    marginTop: '3px',
                    fontWeight: 'bold'
                  }}>
                    {totalTimeElapsed >= breakpoint1 ? '✅ Triggered' : `⏳ ${breakpoint1 - totalTimeElapsed}s remaining`}
                  </div>
                )}
              </div>

              {/* Breakpoint 2 */}
              <div style={{
                backgroundColor: '#d1ecf1',
                padding: '8px 12px',
                borderRadius: '4px',
                border: '1px solid #17a2b8',
                flex: '1',
                minWidth: '150px'
              }}>
                <div style={{ 
                  fontWeight: 'bold', 
                  color: '#0c5460',
                  marginBottom: '4px',
                  fontSize: '10px',
                  textTransform: 'uppercase'
                }}>
                  🎯 Breakpoint 2
                </div>
                <div style={{ 
                  color: '#0c5460', 
                  fontWeight: 'bold',
                  fontSize: '13px',
                  fontFamily: 'monospace',
                  lineHeight: '1.3'
                }}>
                  {breakpoint2 !== null ? `${breakpoint2}s` : 'Not Set'}
                </div>
                {breakpoint2 !== null && totalTimeElapsed !== null && (
                  <div style={{ 
                    color: totalTimeElapsed >= breakpoint2 ? '#dc3545' : '#28a745',
                    fontSize: '10px',
                    marginTop: '3px',
                    fontWeight: 'bold'
                  }}>
                    {totalTimeElapsed >= breakpoint2 ? '✅ Triggered' : `⏳ ${breakpoint2 - totalTimeElapsed}s remaining`}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </>
  );
};
export default Dashboard;
